// extracted by extract-css-chunks-webpack-plugin
module.exports = {"gallery-title":"ZEwAw","message-wrapper":"jXj3-","title-container":"btGfX","message-heading":"_55MAf"};